import fileTypeJpgImg from '@/assets/icons/file-types/FileTypeJPG.png';
import fileTypeJpegImg from '@/assets/icons/file-types/FileTypeJPEG.png';
import fileTypeGifImg from '@/assets/icons/file-types/FileTypeGIF.png';
import fileTypePdfImg from '@/assets/icons/file-types/FileTypePDF.png';
import fileTypeTxtImg from '@/assets/icons/file-types/FileTypeTXT.png';
import fileTypePptImg from '@/assets/icons/file-types/FileTypePPT.png';
import fileTypePptxImg from '@/assets/icons/file-types/FileTypePPTX.png';
import fileTypeXlsImg from '@/assets/icons/file-types/FileTypeXLS.png';
import fileTypeXlsxImg from '@/assets/icons/file-types/FileTypeXLSX.png';
import fileTypePngImg from '@/assets/icons/file-types/FileTypePNG.png';
import fileTypeSvgImg from '@/assets/icons/file-types/FileTypeSVG.png';
import fileTypeDocImg from '@/assets/icons/file-types/FileTypeDOC.png';
import fileTypeDocxImg from '@/assets/icons/file-types/FileTypeDOCX.png';
import fileTypeEmptyImg from '@/assets/icons/file-types/FileTypeEmpty.png';

export default () => {
  const getFileExtension = (filename: string) => {
    return filename.split('.').pop()?.toLowerCase() || '';
  };

  const getImageIcon = (filename: string) => {
    if (!filename) return fileTypeEmptyImg;

    const ext = filename.split('.').pop();
    if (!ext) {
      return fileTypeEmptyImg;
    }

    switch (ext.toLowerCase()) {
      case 'jpg':
        return fileTypeJpgImg;

      case 'jpeg':
        return fileTypeJpegImg;

      case 'gif':
        return fileTypeGifImg;

      case 'png':
        return fileTypePngImg;

      case 'docx':
        return fileTypeDocxImg;

      case 'doc':
        return fileTypeDocImg;

      case 'ppt':
        return fileTypePptImg;

      case 'pptx':
        return fileTypePptxImg;

      case 'xls':
        return fileTypeXlsImg;

      case 'xlsx':
        return fileTypeXlsxImg;

      case 'svg':
        return fileTypeSvgImg;

      case 'txt':
        return fileTypeTxtImg;

      case 'pdf':
        return fileTypePdfImg;
    }

    return fileTypeEmptyImg;
  };

  const getReadableFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';

    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    const size = bytes / Math.pow(k, i);
    return `${size.toFixed(1)} ${units[i]}`;
  };

  const convertBase64ToPdfWindowUrl = (base64: string) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const url = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/pdf' }));
    return url;
  };

  const getValidFiles = (files: File[]) => {
    const validFiles = [];
    const allowedExtensions = [
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-powerpoint', // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
      'text/plain', // .txt
      'application/vnd.oasis.opendocument.text', // .odt
    ];

    const isImage = (type: string) => type.startsWith('image/');
    for (const file of files) {
      if (allowedExtensions.includes(file.type) || isImage(file.type)) {
        validFiles.push(file);
      }
    }
    return validFiles;
  };

  const convertAndDownloadDocument = (bytes: any, filename: string) => {
    const byteCharacters = atob(bytes);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const url = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  };

  const convertDocumentToBase64 = (bytes: any) => {
    const byteCharacters = atob(bytes);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const binaryString = String.fromCharCode(...byteArray);

    const base64String = btoa(binaryString);

    return base64String;
  };

  const extractFilenameFromUrl = (url: string): string => {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const filename = pathname.split('/').pop();
      return filename || '';
    } catch (error) {
      console.error('Error parsing URL:', error);
      return '';
    }
  };

  const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result as string;
        resolve(dataUrl.split(',')[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  return {
    blobToBase64,
    getImageIcon,
    getValidFiles,
    getFileExtension,
    getReadableFileSize,
    extractFilenameFromUrl,
    convertDocumentToBase64,
    convertAndDownloadDocument,
    convertBase64ToPdfWindowUrl,
  };
};
